import {
  Box,
  Button,
  Divider,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import styled from "styled-components";
import { HashLink } from "react-router-hash-link";

import AvatarImage from "../../../../assets/images/avatar-icon.svg";

type ItemProp = {
  $last?: boolean;
};

export const StyledBox = styled.header`
  position: relative;
  transform: scale(1);
  background-color: #ffffff;
  box-shadow: 0px 2px 5px rgba(115, 137, 169, 0.25);
  border-radius: 0;
  padding: 37px 63px;

  @media (max-width: 599px) {
    padding: 24px 20px;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const LogoButton = styled.button`
  appearance: none;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const LogoImage = styled.img`
  display: block;
  height: 37px;
  width: 150px;

  @media (max-width: 475px) {
    height: 30px;
    width: 120px;
  }
`;

export const AvatarIcon = styled(Button)`
  background-image: url(${AvatarImage});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 40px;
  width: 40px;

  && {
    @media (max-width: 475px) {
      height: 24px;
      width: 24px;
    }
  }
`;

export const AvatarName = styled(Typography)`
  && {
  }
`;

export const AvatarLogoutButton = styled.a`
  && {
    font-weight: 200;
    cursor: pointer;
  }
`;

export const MenuIcon = styled.img`
  display: block;
  height: 12px;
  width: 18px;
`;

export const AvatarContainer = styled(Box)`
  && {
    display: flex;
    align-items: center;
    text-decoration: none;
    height: 40px;
  }
`;

export const Navbar = styled.nav`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: center;

  @media (max-width: 599px) {
    display: none;
  }
`;

export const NavLink = styled(HashLink)`
  && {
    font-family: "Figtree", "Roboto", "sans-serif";
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    text-decoration: none;
    color: #001e64;
    margin: 0 10px;
  }

  &:hover {
    cursor: pointer;
    color: #ff8c00;
  }
`;

export const NavDivider = styled(Divider)`
  && {
    height: 25px;
    width: 1px;
    margin: 0 18px;
    text-align: center;
    align-items: center;
    border: none;
    background-color: #323232;
  }
`;

export const MobileMenuContainer = styled.div`
  display: none;

  @media (max-width: 599px) {
    display: flex;
    align-items: center;
  }
`;

export const MenuButton = styled(Button)`
  && {
    min-width: auto;
    padding: 8px;
  }
`;

export const StyledMenu = styled(Menu)`
  && .MuiPaper-root {
    padding-top: 10px;
  }
`;

export const StyledMenuItem = styled(MenuItem)<ItemProp>`
  && {
    margin-bottom: 16px;
  }

  &&:last-of-type {
    margin-bottom: 8px;
  }
`;

export const MenuLink = styled(HashLink)`
  && {
    font-family: "Figtree", "Roboto", "sans-serif";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-decoration: none;
    color: #323232;
  }
`;

export const CorrectorBar = styled(Box)`
  && {
    width: 100%;
    padding: 10px 0;
    background-color: #146efa;
    color: #ffffff;
    text-align: center;
  }
`;

export const CorrectorBarText = styled(Typography)`
  && {
    font-weight: 600;
  }
`;
